import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';

export const Container = styled.div`
    color: ${ ({ theme: { textColor } }) => textColor };
    height: 100%;
    min-width: 1000px;
`;

export const DataCol = styled(Col_)`
    align-items: center;
    border-right: 1px solid ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    display: flex;
    justify-content: ${ ({ justifycontent }) => justifycontent ?? 'center' };
    :last-child {
        border-right: none;
    }
`;

export const DataContainer = styled.div`
    max-height: calc(100% - 50px);
    overflow-y: scroll;
`;

export const DataRow = styled(Row_)`
    border-bottom: 1px solid ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 12px;
    padding: 5px 10px;
    margin: 0px;
    :nth-child(odd) {
        background-color: #F3F3F3;
    }
`;

export const HeaderCol = styled(Col_)`
    align-items: center;
    border-right: 1px solid ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    ${ ({ cursor }) => cursor ? `cursor: ${ cursor };` : '' }
    display: flex;
    font-size: 12px;
    font-weight: bold;
    justify-content: center;
    text-align: center;
    :last-child {
        border-right: none;
    }
`;

export const HeaderRow = styled(Row_)`
    border-bottom: 1px solid ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    padding: 5px 10px;
    height: 50px;
    margin: 0px;
    width: calc(100% - 17px);
`;

export const Link = styled.div`
    cursor: pointer;
    display: inline-flex;
    font-weight: 500;
    padding: 0px 5px;
`;

export const Message = styled.div`
    font-size: 14px;
    margin: 10px 0px 0px 15px;
`;

export const ModalContainer = styled.div`
    padding: 20px;
`;
